import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const adminDebugApi = axios.create({
  baseURL: '/api/v1/admin/debug',
  withCredentials: true
});

adminDebugApi.interceptors.request.use(
  (config) => {
    const token = getAdminToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

adminDebugApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.href = '/web/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export const getDebugEnabled = async () => {
  const response = await adminDebugApi.get('/enabled');
  return response.data;
};

export const listDebugPatients = async (params = {}) => {
  const response = await adminDebugApi.get('/patients', { params });
  return response.data;
};

export const seedFollowUp = async (payload) => {
  const response = await adminDebugApi.post('/seed-follow-up', payload);
  return response.data;
};

export const resetPatient = async (payload) => {
  const response = await adminDebugApi.post('/reset-patient', payload);
  return response.data;
};
